import React from 'react';
import { processClosing, processFollowUp, processHeading, processQuestions, processSteps } from '../../data/process';

// Phones use the same 18% / 36% rhythm as large desktop; tablet keeps its tighter steps.
const CLAUSE_STEP = ['', 'ml-[18%] md:ml-[12%] lg:ml-[18%]', 'ml-[36%] md:ml-[24%] lg:ml-[36%]'];
const CLAUSE_TONE = ['text-ridge', 'text-ink', 'text-graphite'];
export function ProcessSection() {
  return <section id="process" aria-labelledby="process-title" className="grain scroll-mt-16 bg-vapor md:scroll-mt-[72px]" data-id="element-103" data-mp="2cyiwe3m871u9">
      <div className="mx-auto max-w-page px-6 py-24 md:px-12 md:py-32 xl:px-20" data-id="element-104" data-mp="2gz2t562w03fv">
        <div className="grid gap-8 lg:grid-cols-12 lg:gap-8" data-id="element-105" data-mp="2lsx7rv3mxs83">
          <h2 id="process-title" className="font-display text-[34px] font-light leading-[1.12] tracking-[-0.01em] text-graphite md:text-[48px] lg:col-span-4" data-id="element-106" data-mp="2qqfhvote2dho">
            {processHeading}
          </h2>
          <div className="lg:col-span-8" data-id="element-107" data-mp="30pocmjw2vw53">
            <p className="font-display text-[26px] font-light leading-[1.3] text-graphite md:text-[34px] md:leading-[1.28]" data-id="element-108" data-mp="3qnrs06y9vga6">
              {processQuestions.map((q, i) => <React.Fragment key={q} data-id="element-109" data-mp="3lndlitcbkee9" data-mpi={i}>
                  <span className="block" data-id="element-110" data-mp="3gp2868mtflra">{q}</span>
                  {i < processQuestions.length - 1 ? ' ' : null}
                </React.Fragment>)}
            </p>
            <p className="mt-6 max-w-[48ch] text-[17px] leading-[1.6] text-ridge md:mt-8 md:text-[19px]" data-id="element-111" data-mp="d8vgl0hodeyv">{processFollowUp}</p>
          </div>
        </div>

        <ol role="list" className="mt-16 grid md:mt-24 lg:grid-cols-4 lg:gap-8" data-id="element-112" data-mp="8b3h9lepaqkn">
          {processSteps.map(s => <li key={s.n} className="relative border-l border-ink pb-12 pl-7 last:pb-0 md:pl-8 lg:pb-0" data-id="element-113" data-mp="3gz60pyejwdr">
              <span aria-hidden="true" className="absolute left-0 top-[12px] h-px w-[15px] -translate-x-1/2 bg-ink" data-id="element-114" data-mp="3vkrygiz1al1t" />
              <p aria-hidden="true" className="font-display text-[24px] leading-none tabular-nums text-ridge" data-id="element-115" data-mp="r8o4yp5qbj3o">
                {s.n}
              </p>
              <h3 className="mt-5 font-display text-[28px] leading-[1.15] text-graphite md:text-[32px]" data-id="element-116" data-mp="2lhtcpsry0ktz">{s.title}</h3>
              <p className="mt-4 text-[16px] font-medium leading-[1.55] text-ink" data-id="element-117" data-mp="2qete3qdukzer">{s.lead}</p>
              <p className="mt-2 max-w-[44ch] text-[15px] leading-[1.65] text-ridge" data-id="element-118" data-mp="2bqf48vi0kaop">{s.body}</p>
            </li>)}
        </ol>

        {/* Three clauses step down from the crown to the ground, like the trunks in the mark. */}
        <p className="mt-20 font-display text-[20px] font-light leading-[1.3] md:mt-28 md:text-[32px] md:leading-[1.3] lg:text-[36px]" data-id="element-119" data-mp="27otv9l8logjs">
          {processClosing.map((clause, i) => <React.Fragment key={clause.join(' ')} data-id="element-120" data-mp="1su77kg32h850" data-mpi={i}>
              <span className={`block border-l border-ink py-5 pl-4 md:py-4 md:pl-8 md:[text-wrap:balance] ${CLAUSE_STEP[i]} ${CLAUSE_TONE[i]}`} data-id="element-121" data-mp="1xrp6rera88zt">
                {clause.map((phrase, j) => <React.Fragment key={phrase} data-id="element-122" data-mp="3s45jmyel2ldn" data-mpi={j}>
                    {j > 0 ? ' ' : null}
                    <span className="max-md:block" data-id="element-123" data-mp="1gi4vs5mked71">{phrase}</span>
                  </React.Fragment>)}
              </span>
              {i < processClosing.length - 1 ? ' ' : null}
            </React.Fragment>)}
        </p>
      </div>
    </section>;
}